import {
  SMTP_SETTING_REQUEST,
  SMTP_SETTING_SUCCESS,
  SMTP_SETTING_ERROR,
  SMTP_SETTING_SET,
  SMTP_SETTING_CREATE_REQUEST,
  SMTP_SETTING_UPDATE_REQUEST,
  SMTP_SETTING_UPDATE_SUCCESS,
  SMTP_SETTING_UPDATE_ERROR
} from './smtp-setting.type'

import ApiRest from '@/api/api-rest'

const state = {
  smtpSettingReqStatus: '',
  smtpSettings: {
    useSmtpFlag: undefined,
    description: undefined,
    servername: undefined,
    port: undefined,
    username: undefined,
    connectionSecurity: undefined
  },
  smtpSettingUpdateReqStatus: ''
}

const getters = {
  smtpSettingReqStatus: state => state.smtpSettingReqStatus,
  smtpSettings: state => state.smtpSettings,
  smtpSettingUpdateReqStatus: state => state.smtpSettingUpdateReqStatus
}

// Best Practice - updates state
const mutations = {
  [SMTP_SETTING_REQUEST]: state => (state.smtpSettingReqStatus = 'loading'),
  [SMTP_SETTING_SUCCESS]: state => (state.smtpSettingReqStatus = 'saved'),
  [SMTP_SETTING_ERROR]: state => (state.smtpSettingReqStatus = 'error'),
  [SMTP_SETTING_SET]: (state, settings) => {
    state.smtpSettings = settings
  },
  [SMTP_SETTING_UPDATE_REQUEST]: state =>
    (state.smtpSettingUpdateReqStatus = 'inprogress'),
  [SMTP_SETTING_UPDATE_SUCCESS]: state =>
    (state.smtpSettingUpdateReqStatus = 'saved'),
  [SMTP_SETTING_UPDATE_ERROR]: state =>
    (state.smtpSettingUpdateReqStatus = 'error')
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [SMTP_SETTING_REQUEST] (context, account) {
    context.commit(SMTP_SETTING_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('setting/smtp')
        .then(({ data }) => {
          context.commit(SMTP_SETTING_SUCCESS)
          context.commit(SMTP_SETTING_SET, {
            useSmtpFlag: data.use_smtp_flag,
            description: data.description,
            servername: data.server_name,
            port: data.port,
            username: data.username,
            connectionSecurity: data.connection_security
          })
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(SMTP_SETTING_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [SMTP_SETTING_CREATE_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(SMTP_SETTING_UPDATE_REQUEST)
      ApiRest()
        .post('setting/smtp', {
          useSmtpFlag: payload.useSmtpFlag,
          description: payload.description,
          servername: payload.servername,
          port: payload.port,
          username: payload.username,
          password: payload.password,
          connectionSecurity: payload.connectionSecurity
        })
        .then(resp => {
          context.commit(SMTP_SETTING_UPDATE_SUCCESS, resp)
          context.commit(SMTP_SETTING_SET, payload)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(SMTP_SETTING_UPDATE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [SMTP_SETTING_UPDATE_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(SMTP_SETTING_UPDATE_REQUEST)
      ApiRest()
        .put('setting/smtp', {
          useSmtpFlag: payload.useSmtpFlag,
          description: payload.description,
          servername: payload.servername,
          port: payload.port,
          username: payload.username,
          password: payload.password,
          connectionSecurity: payload.connectionSecurity
        })
        .then(resp => {
          context.commit(SMTP_SETTING_UPDATE_SUCCESS, resp)
          context.commit(SMTP_SETTING_SET, payload)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(SMTP_SETTING_UPDATE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/smtp/smtp-setting.module.js